import React from 'react';
import { Button, notification } from 'antd';
import { PartyTypes } from 'vdlib';
import { useOnlineAuctions } from 'lib/realtime';

const LiveAuctionsManager = ({
  fetchOnlineAuctions,
  onLiveAuctionEnded,
  onLiveAuctionOutbid,
  onLiveAuctionStarted,
  partyType,
  setShowOnline,
  showOnline,
}) => {
  React.useEffect(() => {
    if (
      partyType &&
      fetchOnlineAuctions &&
      partyType.Description === PartyTypes.Merchant
    )
      fetchOnlineAuctions();
  }, [fetchOnlineAuctions, partyType]);

  // Keep online drawer visibility data in ref, otherwise need to unsub/resubscribe
  const onlineRef = React.useRef({ setShowOnline, showOnline });
  React.useEffect(() => {
    onlineRef.current = { setShowOnline, showOnline };
  }, [setShowOnline, showOnline]);

  // TODO: Per party type handlers
  const handleAuctionEnded = React.useCallback(
    payload => {
      const { Amount, BidderID, ID } = payload;
      onLiveAuctionEnded(payload);
      notification.info({
        description: `Η δημοπρασία ${ID} έληξε με νικητήρια προσφορά στα ${Amount} €`,
        message: 'Τέλος live δημοπρασίας',
        top: 56,
      });
    },
    [onLiveAuctionEnded]
  );

  const getOpenAuctionsDrawerHandler = key => () => {
    notification.close(key);
    onlineRef.current.setShowOnline(true);
  };

  const handleAuctionStarted = React.useCallback(
    payload => {
      const { Bids = [], ID } = payload;
      onLiveAuctionStarted(payload);
      if (!onlineRef.current.showOnline) {
        const max = Bids.reduce((curr, bid) => Math.max(curr, bid.Amount), 0);
        const bidders = Bids.map(b => b.BidderID).join(', ');
        const key = `auction-notification-${payload.ID}`;
        notification.info({
          description: (
            <div>
              Η δημοπρασία {ID} ξεκινάει από τα {max} €
              {!onlineRef.current.showOnline && (
                <Button type="link" onClick={getOpenAuctionsDrawerHandler(key)}>
                  Άνοιγμα Live Δημοπρασιών
                </Button>
              )}
            </div>
          ),
          key,
          message: 'Έναρξη live δημοπρασίας',
          top: 56,
        });
      }
    },
    [onLiveAuctionStarted]
  );

  const handleBidPlaced = React.useCallback(
    payload => {
      onLiveAuctionOutbid(payload);
      if (!onlineRef.current.showOnline) {
        const { Amount, AuctionID, BidderID } = payload;
        const key = `outbid-notification-${payload.ID}`;
        notification.warn({
          description: (
            <div>
              Νέα προσφορά στα {Amount} € για τη δημοπρασία {AuctionID}
              {!onlineRef.current.showOnline && (
                <Button type="link" onClick={getOpenAuctionsDrawerHandler(key)}>
                  Άνοιγμα Live Δημοπρασιών
                </Button>
              )}
            </div>
          ),
          key,
          message: 'Έγινε μεγαλύτερη προσφορά',
          top: 56,
        });
      }
    },
    [onLiveAuctionOutbid]
  );

  useOnlineAuctions(handleAuctionStarted, handleAuctionEnded, handleBidPlaced);

  return <span style={{ display: 'none' }} />;
};

export default LiveAuctionsManager;
